import { ApiError } from "../api/client";

export type PageErrorState = {
  message: string | null;
  debugMessage: string | null;
  allowRetry: boolean;
};

export function createPageErrorState(): PageErrorState {
  return {
    message: null,
    debugMessage: null,
    allowRetry: false
  };
}

export function formatApiError(error: unknown): string {
  if (error instanceof ApiError) {
    const debugFields =
      error.debug && typeof error.debug === "object"
        ? Object.entries(error.debug)
            .filter(([, value]) => value !== undefined && value !== null && value !== "")
            .map(([key, value]) =>
              typeof value === "string" || typeof value === "number" || typeof value === "boolean"
                ? `debug.${key}: ${String(value)}`
                : `debug.${key}: ${JSON.stringify(value)}`
            )
        : [];
    const lines = [
      `HTTP ${error.status}`,
      error.code ? `code: ${error.code}` : null,
      error.message ? `message: ${error.message}` : null,
      ...debugFields
    ].filter((line): line is string => Boolean(line));

    return lines.join("\n");
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return "Unexpected error";
}
